// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__V8fyQ","inputWrap":"styles_inputWrap__JKUon","input":"styles_input__fXZEJ"};